
export default {
  name: 'Pagination',

  props: {
    totalPages: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      pages: [],
    };
  },

  computed: {
    isDisabledPrev() {
      return this.currentPage <= 1;
    },
    isDisabledNext() {
      return this.currentPage >= this.totalPages;
    },
  },

  watch: {
    totalPages() {
      this.initPages();
    },
    currentPage() {
      this.initPages();
    },
  },

  mounted() {
    this.initPages();
  },

  methods: {
    initPages() {
      const page = this.currentPage;
      const siblingCount = 1;
      const boundaryCount = 1;
      const count = this.totalPages;
      const range = function range(start, end) {
        const length = end - start + 1;
        return Array.from(
          {
            length,
          },
          (_, i) => start + i,
        );
      };

      const startPages = range(1, Math.min(boundaryCount, count));
      const endPages = range(
        Math.max(count - boundaryCount + 1, boundaryCount + 1),
        count,
      );
      const siblingsStart = Math.max(
        Math.min(
          page - siblingCount,
          count - boundaryCount - siblingCount * 2 - 1,
        ),
        boundaryCount + 2,
      );
      const siblingsEnd = Math.min(
        Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2),
        endPages[0] - 2,
      );

      const items = [].concat(
        startPages,
        // eslint-disable-next-line no-nested-ternary
        siblingsStart > boundaryCount + 2
          ? ['start-ellipsis']
          : boundaryCount + 1 < count - boundaryCount
            ? [boundaryCount + 1]
            : [],
        range(siblingsStart, siblingsEnd),
        // eslint-disable-next-line no-nested-ternary
        siblingsEnd < count - boundaryCount - 1
          ? ['end-ellipsis']
          : count - boundaryCount > boundaryCount
            ? [count - boundaryCount]
            : [],
        endPages,
      );

      this.pages = items.map((item) => {
        if (typeof item === 'number') {
          return {
            title: item,
            page: item
          };
        }

        return {
          title: '...',
          disabled: true
        };
      });
    },

    changePage(newPage) {
      if (newPage < 1 || newPage > this.totalPages || newPage === this.currentPage) {
        return;
      }

      this.$emit('onChangePage', newPage);
    },
  },
};
